import React from 'react';

const PageShell = ({ children, className = '' }) => (
  <div
    className={`w-full max-w-full overflow-x-hidden bg-gradient-to-br from-brand-primary via-brand-secondary to-brand-primary text-brand-cream min-h-screen font-sans antialiased selection:bg-brand-gold-light selection:text-brand-primary ${className}`}
  >
    <div className="motion-flares fixed top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0" aria-hidden="true">
      <div className="absolute top-[-10%] left-[-10%] w-[60%] h-[60%] bg-white/20 rounded-full blur-[120px]" />
      <div className="absolute bottom-[-20%] right-[-10%] w-[70%] h-[70%] bg-brand-primary/40 rounded-full blur-[150px]" />
      <div className="absolute top-[40%] left-[20%] w-[40%] h-[40%] bg-white/10 rounded-full blur-[100px]" />
    </div>
    <div className="relative z-10">{children}</div>
  </div>
);

export default PageShell;
